<script setup>
import { ref, computed } from 'vue'
import Width from "@/pages/Index/Width.vue";
import { useStore } from "vuex";
import {useRouter} from "vue-router";

const router = useRouter()

const store = useStore()

const currentLang = computed(() => store.getters.currentLanguage)

const list = computed(() => {
	return [
		{
			title: 'footer.blockTitles.about',
			blocks: [
				{
					title: 'footer.home',
					path: '/'
				},
				{
					title: 'footer.news',
					path: '/newsInformation'
				},
				{
					title: 'footer.contact',
					path: '/contactus'
				},
			]
		},
		{
			title: 'footer.blockTitles.moldManufacturing',
			blocks: [
				{
					title: 'footer.power',
					path: '/manufacture'
				},
				{
					title: 'footer.customerCase',
					path: '/customer-case'
				},
				{
					title: 'footer.product',
					path: '/productDisplay'
				}
			]
		},
		{
			title: 'footer.blockTitles.friendlyLinks',
			blocks: [
				{
					title: 'footer.moldCloud',
					path: 'https://www.mouldc.com/'
				}
			]
		}
	]
})

const info = computed(() => {
	return [
		{
			icon: 'phone',
			label: 'footer.phone',
			value: store.state.companyInfo?.contact_phone
		},
		{
			icon: 'fax',
			label: 'footer.fax',
			value: store.state.companyInfo?.facsimile
		},
		{
			icon: 'internet',
			label: 'footer.website',
			value: ''
		}
	]
})

const getQrCodeInfo = computed(() => {
	const info = store.state.companyInfo
	return [
		{
			title: info?.[`left_title_${currentLang.value}`],
			img: info?.[`left_image_${currentLang.value}`]
		},
		{
			title: info?.[`right_title_${currentLang.value}`],
			img: info?.[`right_image_${currentLang.value}`]
		}
		// {
		// 	title: info?.[`right_title_most_${currentLang.value}`],
		// 	img: info?.[`right_image_most_${currentLang.value}`]
		// }
	]
})

const recordNumber = computed(() => store.state.companyInfo?.record_number)

const handleToPage = (path) => {
	const httpPrefixReg = /https{0,1}:\/\//
	if(httpPrefixReg.test(path)){
		window.open(path)
	}else{
		toPage(path)
	}
}

function toPage(path){
	router.push(path)
	window.scrollTo({
		top: 0,
		left: 0,
		behavior: 'smooth'
	})
}
</script>

<template>
	<div class="footer">
		<div class="footer__menu">
			<el-menu>
				<el-sub-menu v-for="(block,index) in list" :index="`${index}`" :key="index">
					<template #title>
						<div class="block-title">
							{{ $t(block.title) }}
						</div>
					</template>
					<el-menu-item
						style="padding-left: 40px;"
						v-for="(item,i) in block.blocks"
						:index="`${index}-${i}`"
						@click="handleToPage(item.path)"
						:key="i"
					>
						{{ $t(item.title) }}
					</el-menu-item>
				</el-sub-menu>
			</el-menu>
		</div>
		<div class="footer__info">
			<div class="left">
				<SvgIcon name="logo" class-name="icon" />
				
				<div class="website-info">
					<div>
						<a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index" class="link">
							{{ $t('footer.record') }}{{ recordNumber }}
						</a>
					</div>
					
					<div>{{ $t('footer.copyright') }}</div>
					
					<div>
						<a
							target="_blank"
							href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33020702000029"
							class="link"
						>
							浙公网安备 33020702000029号
						</a>
					</div>
				</div>
				
			</div>
			
			<div class="right">
				<div
					v-for="(img, mIndex) in getQrCodeInfo"
					:key="mIndex"
					class="right__qrcode"
				>
					<div class="right__qrcode__img">
						<el-image
							:src="img.img"
							style="width: 100%;height: 100%"
							fit="cover"
						/>
					</div>
					
					<div class="right__qrcode__title">{{ img.title }}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped lang="less">
.footer {
	background: #2F3030;
	
	.block-title {
		font-size: 14px;
		font-weight: bold;
	}
	
	.el-sub-menu .el-menu {
		--el-menu-bg-color: #2F3030;
		--el-menu-text-color: #fff;
		--el-menu-hover-bg-color: #2F3030;
	}
	
	.el-menu-item {
		background-color: #212121;
	}
	
	.el-menu {
		--el-menu-bg-color: transparent;
		--el-menu-text-color: #fff;
		--el-menu-hover-bg-color: #333;
	}
	
	&__info {
		padding: 20px;
		display: flex;
		justify-content: space-between;
		
		.icon {
			width: 160px;
			height: 23px;
		}
		
		.left {
			color: rgba(255, 255, 255, .5);
			font-size: 12px;
			.website-info {
				margin-top: 7px;
				
				>div {
					margin-top: 7px;
				}
			}
			
			a {
				color: rgba(255, 255, 255, .5);
			}
		}
		
		.right {
			display: flex;
			justify-content: space-between;
			&__qrcode {
				width: calc(100% / 2);
				margin-right: 15px;
				color: rgba(255, 255, 255, 0.5);
				display: flex;
				flex-direction: column;
				align-items: center;
				
				&:last-child {
					margin-right: 0;
				}
				
				&__img {
					width: 50px;
					height: 50px;
				}
				
				&__title {
					font-size: 12px;
					text-align: center;
					margin-top: 6px;
				}
			}
			
			
		}
	}
}
</style>